import clsx from 'clsx';
import type { ComponentPropsWithoutRef, ForwardedRef } from 'react';
import { forwardRef } from 'react';
import { Text } from '../Text';
import styles from './Input.module.scss';
export type InputProps = {
  as?: 'input' | 'textarea';
  customLabel?: string;
  error?: {
    message?: string;
  };
  hidePlaceholderOnFocus?: boolean;
  inputClassName?: string;
  isFilled?: boolean;
  isRequired?: boolean;
} & ComponentPropsWithoutRef<'input'>;
const InputWithoutRef = ({
  as: As = 'input',
  className,
  customLabel,
  error,
  hidePlaceholderOnFocus,
  inputClassName,
  isFilled,
  isRequired,
  ...inputHTMLAttrs
}: InputProps, ref: ForwardedRef<any>) => {
  return <div className={clsx(styles.wrapper, className, hidePlaceholderOnFocus && styles.hidePlaceholderOnFocus, customLabel && styles.withCustomLabel, error && styles.isError)} data-sentry-component="InputWithoutRef" data-sentry-source-file="Input.tsx">
      <As className={clsx(styles.input, inputHTMLAttrs.placeholder && styles.withLabel, (inputHTMLAttrs.value || isFilled) && styles.filled, inputClassName)} {...inputHTMLAttrs as Record<string, unknown>} ref={ref} data-sentry-element="As" data-sentry-source-file="Input.tsx" />
      {customLabel && <Text className={styles.customLabel} color='text-gray' tag='span' type='p4'>
          {customLabel}
        </Text>}
      {inputHTMLAttrs.placeholder && <Text className={styles.label} color='text-gray' tag='span' type='field_text'>
          {inputHTMLAttrs.placeholder}
        </Text>}
      {isRequired && <Text className={styles.requiredAsterisk} color='red' tag='span' type='field_text'>
          *
        </Text>}
      {error?.message && <span className={styles.errorMessage}>{error.message}</span>}
    </div>;
};
export const Input = forwardRef(InputWithoutRef);